const Theme = {
  colors: {
    primary: "#1B4235",
    primaryLight: "#9BC1BC",
    secondary: "#f5c469",
    tertiary: "F4F1BB",
  },
  sizes: {
    mobileS: "320px",
    mobileM: "375px",
    mobileL: "425px",
    tablet: "768px",
    laptop: "1024px",
    laptopL: "1440px",
    desktop: "2560px",
  },
};

export default Theme;
